var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "alien"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 90,
    rx: 50,
    ry: 60,
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 70,
    rx: 20,
    ry: 25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 70,
    rx: 20,
    ry: 25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 70,
    rx: 8,
    ry: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 70,
    rx: 8,
    ry: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 110,
    rx: 10,
    ry: 5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,130 Q100,150 130,130",
    fill: "none",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "robot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 100,
    height: 80,
    rx: 10,
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 80,
    height: 40,
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 70,
    r: 15,
    fill: "#4f46e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 70,
    r: 15,
    fill: "#4f46e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 70,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 70,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 90,
    width: 30,
    height: 10,
    fill: "#4f46e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 160,
    width: 15,
    height: 20,
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 160,
    width: 15,
    height: 20,
    fill: "#c7d2fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ninja"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 60,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 80,
    width: 100,
    height: 25,
    rx: 12,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 87,
    rx: 10,
    ry: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 87,
    rx: 4,
    ry: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 87,
    rx: 10,
    ry: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 87,
    rx: 4,
    ry: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 150,
    x2: 70,
    y2: 130,
    stroke: "#ef4444",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 150,
    x2: 130,
    y2: 130,
    stroke: "#ef4444",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "unicorn"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 100,
    r: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,70 L170,40 L150,75",
    fill: "#f472b6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 85,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,115 Q110,130 135,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,50 Q130,20 140,50",
    fill: "none",
    stroke: "#f472b6",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,150 Q130,160 145,150 Q160,140 150,130",
    fill: "#f472b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,160 L100,170 L110,160",
    fill: "#f472b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pirate"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 85,
    width: 20,
    height: 25,
    rx: 10,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,67 L130,120",
    stroke: "#f59e0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 100,
    r: 6,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,120 Q100,135 125,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,65 H145",
    stroke: "#0f172a",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,55 Q100,40 130,55 L130,65 L70,65 Z",
    fill: "#0f172a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "devil"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#fca5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,50 Q65,30 60,50",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,50 Q135,30 140,50",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 85,
    rx: 8,
    ry: 12,
    fill: "#7f1d1d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 85,
    rx: 8,
    ry: 12,
    fill: "#7f1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,115 Q100,125 115,115",
    fill: "none",
    stroke: "#7f1d1d",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "ghost"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,150 C150,110 150,70 100,70 C50,70 50,110 50,150 L70,140 L90,150 L110,140 L130,150 Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 10,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 10,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q100,125 110,120",
    fill: "none",
    stroke: "#1e293b",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "chef"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 40,
    fill: "#fca5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 80,
    height: 50,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,50 Q100,70 140,50",
    fill: "none",
    stroke: "#d1d5db",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,120 Q100,130 115,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 140,
    width: 60,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 140,
    width: 30,
    height: 10,
    fill: "#ef4444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cat"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 50,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,80 Q60,50 80,60",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,80 Q140,50 120,60",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 95,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 95,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,115 L100,125 L110,115",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,110 L70,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,110 L140,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "astronaut"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 40,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 60,
    height: 40,
    rx: 20,
    fill: "#38bdf8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 80,
    r: 15,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 80,
    r: 15,
    fill: "#e2e8f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vampire"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 8,
    fill: "#7f1d1d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 8,
    fill: "#7f1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q100,125 110,120",
    fill: "none",
    stroke: "#7f1d1d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 L95,110",
    fill: "none",
    stroke: "#7f1d1d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,120 L105,110",
    fill: "none",
    stroke: "#7f1d1d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,40 Q80,60 90,40",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,40 Q120,60 110,40",
    fill: "#0f172a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clown"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 10,
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 10,
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 10,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 10,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,120 Q100,140 130,120",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,60 Q70,40 100,50 Q130,40 135,60",
    fill: "#f472b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mummy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#f5f5f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,70 H150",
    stroke: "#d6d3d1",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,85 H150",
    stroke: "#d6d3d1",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,100 H150",
    stroke: "#d6d3d1",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,115 H150",
    stroke: "#d6d3d1",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,130 H150",
    stroke: "#d6d3d1",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 8,
    fill: "#0f172a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "zombie"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#86efac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 12,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 80,
    r: 12,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 4,
    fill: "#86efac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 80,
    r: 4,
    fill: "#86efac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,110 Q100,150 130,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,60 L80,70",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,60 L120,65",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "pumpkin"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 50,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,60 V30",
    stroke: "#15803d",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,40 H110",
    stroke: "#15803d",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,110 Q100,80 130,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,90 L70,85 L80,80",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,90 L130,85 L120,80",
    fill: "#0f172a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "penguin"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 120,
    rx: 40,
    ry: 50,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 120,
    rx: 30,
    ry: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 30,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 70,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,85 H110",
    stroke: "#f97316",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,90 C80,110 60,120 50,110",
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,90 C120,110 140,120 150,110",
    fill: "#f97316"
  })), /*#__PURE__*/React.createElement("g", {
    id: "koala"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#9ca3af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 20,
    fill: "#6b7280"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 20,
    fill: "#6b7280"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 10,
    fill: "#d1d5db"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 10,
    fill: "#d1d5db"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 95,
    r: 10,
    fill: "#6b7280"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 120,
    rx: 20,
    ry: 10,
    fill: "#6b7280"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lion"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 40,
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,105 Q100,110 110,105",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,60 Q65,50 80,70",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,80 Q65,70 80,90",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,100 Q65,90 80,110",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,60 Q135,50 120,70",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,80 Q135,70 120,90",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,100 Q135,90 120,110",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "panda"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 20,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 20,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 70,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 20,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q100,130 110,120",
    fill: "none",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "frog"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 80,
    rx: 20,
    ry: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 80,
    rx: 20,
    ry: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 80,
    r: 10,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 80,
    r: 10,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,120 Q100,140 140,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,60 Q80,30 100,60",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,60 Q120,30 100,60",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "avocado"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 120,
    rx: 60,
    ry: 50,
    fill: "#84cc16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 120,
    r: 25,
    fill: "#92400e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,130 Q100,140 110,130",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,50 V70",
    stroke: "#92400e",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "cupcake"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,100 Q100,60 140,100 V140 H60 Z",
    fill: "#f9a8d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 140,
    width: 60,
    height: 20,
    fill: "#f5f5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,110 Q100,120 110,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 85,
    r: 8,
    fill: "#38bdf8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 70,
    r: 8,
    fill: "#f43f5e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 85,
    r: 8,
    fill: "#4ade80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sloth"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#d6d3d1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 110,
    rx: 10,
    ry: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,130 V150",
    stroke: "#92400e",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "cow"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,60 Q60,40 70,60",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,60 Q140,40 130,60",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 85,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 85,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 110,
    rx: 15,
    ry: 10,
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 110,
    r: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,70 Q100,85 130,70",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "octopus"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 40,
    fill: "#38bdf8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 70,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,90 Q100,100 110,90",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,100 Q30,130 20,160",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,110 Q60,150 50,180",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,120 Q100,150 100,180",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,110 Q140,150 150,180",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,100 Q170,130 180,160",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "owl"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 80,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 80,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 80,
    r: 10,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 80,
    r: 10,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,120 Q100,130 115,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,110 L100,120",
    stroke: "#f97316",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,50 Q80,40 90,50",
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,50 Q120,40 110,50",
    fill: "#94a3b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cookie"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#92400e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 10,
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 60,
    r: 8,
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 12,
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 130,
    r: 9,
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 110,
    r: 7,
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q100,125 110,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "cactus"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 50,
    width: 40,
    height: 100,
    rx: 10,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,80 H60 V120 H80",
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,100 H140 V140 H120",
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 75,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 75,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,90 Q100,95 110,90",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 60,
    x2: 70,
    y2: 70,
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 90,
    x2: 50,
    y2: 90,
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 130,
    x2: 70,
    y2: 140,
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 80,
    x2: 130,
    y2: 90,
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 120,
    x2: 150,
    y2: 120,
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "burger"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,70 H150 Q160,70 160,80 V80 Q160,90 150,90 H50 Q40,90 40,80 V80 Q40,70 50,70 Z",
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,90 H150 Q160,90 160,100 V100 Q160,110 150,110 H50 Q40,110 40,100 V100 Q40,90 50,90 Z",
    fill: "#84cc16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,110 H150 Q160,110 160,120 V120 Q160,130 150,130 H50 Q40,130 40,120 V120 Q40,110 50,110 Z",
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,130 H150 Q160,130 160,140 V140 Q160,150 150,150 H50 Q40,150 40,140 V140 Q40,130 50,130 Z",
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q100,125 110,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "bunny"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 120,
    r: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,70 Q65,30 85,50",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,70 Q135,30 115,50",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 125,
    rx: 10,
    ry: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,140 L100,150 L115,140",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "superhero"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 60,
    height: 80,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,70 L100,40 L130,70",
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 70,
    width: 30,
    height: 20,
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,100 Q100,105 110,100",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,120 L60,150",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,120 L140,150",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "ice-cream"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,80 Q100,30 130,80 L130,120 L70,120 Z",
    fill: "#f9a8d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,120 L95,170 L105,170 L115,120",
    fill: "#fed7aa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 85,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,100 Q100,105 110,100",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 70,
    r: 5,
    fill: "#f9a8d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 60,
    r: 5,
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 70,
    r: 5,
    fill: "#fcd34d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wizard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,100 L100,30 L140,100",
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 120,
    r: 40,
    fill: "#e9d5ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,130 Q100,135 110,130",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,70 L110,60 L120,70",
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 5,
    fill: "#fcd34d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gamer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 80,
    height: 50,
    rx: 10,
    fill: "#2e1065"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 105,
    r: 5,
    fill: "#f43f5e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 105,
    r: 5,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 105,
    r: 5,
    fill: "#4ade80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 105,
    r: 5,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 60,
    width: 60,
    height: 30,
    rx: 5,
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 75,
    r: 8,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 75,
    r: 8,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,85 L108,85",
    stroke: "#6366f1",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "pig"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#fecdd3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 110,
    rx: 15,
    ry: 10,
    fill: "#f43f5e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 110,
    r: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,90 Q60,70 70,60",
    fill: "#fecdd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,90 Q140,70 130,60",
    fill: "#fecdd3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coffee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,80 H140 V150 Q140,170 100,170 Q60,170 60,150 Z",
    fill: "#92400e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,100 Q160,100 160,120 V130 Q160,150 140,150",
    fill: "none",
    stroke: "#92400e",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,80 H140 V100 H60 Z",
    fill: "#fbbf24",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,130 Q100,140 110,130",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "farmer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 80,
    width: 60,
    height: 70,
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,80 H140",
    stroke: "#0f172a",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 50,
    width: 60,
    height: 30,
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 95,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 95,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,115 Q100,120 110,115",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 30,
    height: 20,
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 140,
    width: 30,
    height: 20,
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,40 Q100,20 130,40",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "sheep"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 110,
    rx: 10,
    ry: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 70,
    r: 10,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 80,
    r: 10,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 100,
    r: 10,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 70,
    r: 10,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 80,
    r: 10,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 100,
    r: 10,
    fill: "#e5e7eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,150 L100,50 L130,150 Z",
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 25,
    fill: "#f5f5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,110 Q100,115 110,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,150 L60,170",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,150 L140,170",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "dinosaur"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,130 Q80,90 120,90 Q150,90 150,120 Q150,150 120,150 L80,150 Q60,150 60,130 Z",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,90 Q130,70 150,60 Q160,50 170,60",
    fill: "none",
    stroke: "#15803d",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,150 L70,180",
    fill: "none",
    stroke: "#15803d",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,150 L130,180",
    fill: "none",
    stroke: "#15803d",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 110,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,90 L150,70 L160,90",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,130 Q105,140 120,130",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "taco"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,100 Q100,30 160,100 Q160,140 100,160 Q40,140 40,100 Z",
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,110 H150",
    fill: "none",
    stroke: "#15803d",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 90,
    r: 10,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 10,
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 90,
    r: 10,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 120,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 120,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,140 Q100,145 110,140",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "monkey"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#b45309"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 15,
    fill: "#fef3c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 15,
    fill: "#fef3c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 115,
    rx: 20,
    ry: 15,
    fill: "#fef3c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 115,
    r: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 115,
    r: 3,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,60 Q55,30 50,60",
    fill: "#b45309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,60 Q145,30 150,60",
    fill: "#b45309"
  })), /*#__PURE__*/React.createElement("g", {
    id: "jellyfish"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,80 Q100,50 140,80 V120 Q100,100 60,120 Z",
    fill: "#e0f2fe",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,110 Q100,115 110,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,120 Q65,150 60,180",
    fill: "none",
    stroke: "#e0f2fe",
    strokeWidth: 5,
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q90,160 90,180",
    fill: "none",
    stroke: "#e0f2fe",
    strokeWidth: 5,
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,120 Q110,160 110,180",
    fill: "none",
    stroke: "#e0f2fe",
    strokeWidth: 5,
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,120 Q135,150 140,180",
    fill: "none",
    stroke: "#e0f2fe",
    strokeWidth: 5,
    strokeOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "sushi"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 60,
    ry: 30,
    fill: "#f5f5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 120,
    height: 30,
    fill: "#fcd34d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70,
    width: 80,
    height: 30,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 85,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 85,
    r: 8,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,100 Q100,105 110,100",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 80,
    height: 5,
    fill: "#84cc16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bee"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 50,
    ry: 40,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 60,
    width: 40,
    height: 80,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 20,
    height: 40,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 80,
    width: 20,
    height: 40,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 80,
    r: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,100 Q100,105 110,100",
    fill: "none",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,80 L140,70",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,100 L140,100",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,120 L140,130",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "llama"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 120,
    rx: 30,
    ry: 50,
    fill: "#fce7f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,70 V30",
    stroke: "#fce7f3",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,30 H110",
    stroke: "#fce7f3",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q100,130 110,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,150 V170",
    stroke: "#fce7f3",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,150 V170",
    stroke: "#fce7f3",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "crab"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 40,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,110 Q100,120 110,110",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,70 Q60,60 60,90",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,110 Q60,100 60,90",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,70 Q140,60 140,90",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,110 Q140,100 140,90",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "detective"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 40,
    fill: "#fef3c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,80 H140",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,50 Q100,70 130,50",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,120 Q100,125 110,120",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,90 Q120,80 130,90",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "raccoon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,70 Q100,90 130,70",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 10,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 10,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 125,
    rx: 10,
    ry: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,50 Q60,40 50,50",
    fill: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,50 Q140,40 150,50",
    fill: "#cbd5e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "space-invader"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 80,
    height: 80,
    fill: "#84cc16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 20,
    height: 20,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 60,
    width: 20,
    height: 20,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 40,
    height: 20,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 20,
    height: 20,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 20,
    height: 20,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 120,
    width: 20,
    height: 20,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 120,
    width: 20,
    height: 20,
    fill: "#0f172a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatars);
export default __webpack_public_path__ + "static/media/avatars.df1e59815b391bde2f73f2183a6cf65e.svg";
export { ForwardRef as ReactComponent };